import React from "react";
import { Link } from "react-router-dom";
import { Table, Space, Button, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { ListComponent, BaseListComponentProps } from "../BaseComponent";
import { SearchRequest } from "../../services/api/interfaces/ApiRequest";
import { SearchOptions } from "../TableHelper";
import { Pagination } from "components/Pagination";

type MappingSizeListProps = BaseListComponentProps & {
  loading: boolean;
  mappingSizes: any;
  pagination: any;
  filters: any | null;
  history?: any;

  loadMappingSizes: (args: SearchRequest) => void;

  onLoad?: (searchOptions: SearchOptions) => void;
};

export default class MappingSizeList extends ListComponent<MappingSizeListProps> {
  static defaultProps = {
    loading: false,
    mappingSizes: [],

    loadMappingSizes: () => {},
  };

  tableColumns = [
    {
      title: "Partner",
      dataIndex: "partner_key",
      key: "partner_key",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.partner_key - b.name,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name - b.name,
    },
    {
      title: "External ID",
      dataIndex: "external_id",
      key: "external_id",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.external_id - b.external_id,
    },
    {
      title: "Size Key",
      dataIndex: "size_key",
      key: "size_key",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.size_key - b.size_key,
    },
    {
      title: 'Shelter',
      dataIndex: ['shelter', 'name'],
      key: 'shelter_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.shelter?.name - b.shelter?.name,
      render: (value: any, record: any, index: number) => record.shelter_id ? value : <Tag children="GLOBAL" />
    },
    {
      title: "Actions",
      key: "action",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link
            to={`size/${record.uuid}`}
            ref={(refs) => this.actionRefs.edit.push(refs)}
          >
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      ),
    },
  ];

  componentDidUpdate(prevProps: any, prevState: any) {
    this.validateAccessPermissions();

    if (prevProps.filters !== this.props.filters) {
      this.load();
    }
  }

  protected load() {
    this.searchOptions = {
      search: {
        ...this.props.filters,
        shelter: {
          with: {
            _fields: ["id", "uuid", "name"]
          },
        },
      },
      options: {
        ...this.searchOptions.options,
        _force_ids: true,
        sort: ["-id"],
      },
    };

    this.props.loadMappingSizes(this.searchOptions);

    if (this.props.onLoad) {
      this.props.onLoad(this.searchOptions);
    }
  }

  render() {
    const { loading, pagination, mappingSizes, loadMappingSizes } = this.props;


    return (
      <>
        <Table
          loading={loading}
          rowKey="uuid"
          columns={this.tableColumns}
          pagination={false}
          dataSource={mappingSizes}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, loadMappingSizes)
          }
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={mappingSizes?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadMappingSizes)
          }
        />
      </>
    );
  }
}
